import { render } from "./footer.html?vue&type=template&id=62f3e343&ts=true&external"
import script from "./footer.ts?vue&type=script&lang=ts&external"
export * from "./footer.ts?vue&type=script&lang=ts&external"

import "./footer.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__